import { isEmpty } from 'lodash'
import { ReactElement, useState } from 'react'
import { defineMessages, useIntl } from 'react-intl'

import { Autocomplete } from 'components/v2/Autocomplete'
import { IAutocompleteProps } from 'components/v2/Autocomplete/types'
import { normalize } from 'utils/string'

const messages = defineMessages({
  empty: {
    id: 'routingProject.location.autocomplete.empty',
    defaultMessage: 'No locations found'
  }
})

export interface ILocationAutocomplete {
  id: string
  label: string
}

interface ILocationAutocompleteProps extends Omit<IAutocompleteProps, 'onChange' | 'items' | 'getItemLabel'> {
  onChange: (location: ILocationAutocomplete) => void
  locations: ILocationAutocomplete[]
}

export const LocationAutocomplete = ({ onChange, locations, ...props }: ILocationAutocompleteProps): ReactElement => {
  const intl = useIntl()
  const [pattern, setPattern] = useState('')

  const handleChange = (location: ILocationAutocomplete, { inputValue = '' } = {}): void => {
    setPattern(inputValue)
    if (!isEmpty(location)) {
      onChange(location)
    } else {
      onChange({
        id: '',
        label: ''
      })
    }
  }

  const shownItems = locations.filter((location) => normalize(location.label).includes(normalize(pattern)))

  return (
    <Autocomplete
      {...props}
      items={shownItems}
      getItemLabel={(location: ILocationAutocomplete): string => location.label}
      emptyMessage={intl.formatMessage(messages.empty)}
      onChange={handleChange}
    />
  )
}
